import axios, { AxiosResponse } from 'axios';

import { IBankAccount } from '../models';
import { authFetch } from './fetch';

const baseUrl = '/api/Admin/BankAccounts';

/**
 * Simplified CRUD/network ops interface for `IBankAccount` resources.
 */
export const IBankAccountsAPI = {
  async getAll(): Promise<IBankAccount[]> {
    try {
      const response: AxiosResponse<IBankAccount[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IBankAccount[]): Promise<IBankAccount[]> {
    try {
      const response: AxiosResponse<IBankAccount[]> = await authFetch.post(baseUrl, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(bankAccountId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${bankAccountId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
    }
  },

  async uploadW9(file: File): Promise<number> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response: AxiosResponse<number> = await authFetch.post(
        `${baseUrl}/w9`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async downloadW9(
  bankAccountId: number,
  fileId: number
  ): Promise<AxiosResponse<Blob>> {
    try {
      const response = await authFetch.getFile(
        `${baseUrl}/${bankAccountId}/w9/${fileId}`,
        {
          responseType: 'blob',
        }
      );
      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  }
};